module.exports = __webpack_public_path__ + "/fonts/500.7789803.svg";